<template>
    <v-dialog
    v-model="shown"
    max-width="500"
  >
    <v-card>
      <v-card-title class="headline">
        Storniraj račun
      </v-card-title>

      <v-card-text>
        <form @submit.prevent="save">
          <v-row>
            <v-col>
              <v-textarea
                v-model="comment"
              />
            </v-col>
          </v-row>
          <div style="height: 30px; margin-top: 20px;">
            <v-btn type="submit" class="float-right">Storniraj</v-btn>
            <v-btn text type="button" class="float-right mr-4" @click="remove">Prekliči</v-btn>
          </div>
        </form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data () {
    return {
      comment: '',
      shown: false
    }
  },
  methods: {
    save () {
      if (this.comment.length) {
        this.$emit('cancelInvoice', this.comment)
        this.shown = false
      }
    },
    remove () {
      this.comment = ''
      this.shown = false
    },
    open () {
      this.comment = 'Komentar'
      this.shown = true
    }
  }
}
</script>
